import {
  IPubsub_Client,
  IPubsub_Message_Type,
  IPubsub_Message_Body,
} from '../../../types/pubsub'

import PubSubClient from '../../../pubsub/client'

let socketClient: IPubsub_Client | null = null

export const getWebsocketUrl = (): string => {
  const protocol = location.protocol == 'https:' ? 'wss' : 'ws'
  return `${protocol}://${location.host}/api/v1/websocket/connect`
}

export const connectWebsocket = async (token: string) => {
  const socket = PubSubClient({
    url: getWebsocketUrl(),
    token,
  })
  await socket.connect()
  socketClient = socket
}

export const disconnectWebsocket = async () => {
  if(!socketClient) return
  socketClient.close()
}

export const getSocketClient = <MessageType = IPubsub_Message_Type, BodyType = IPubsub_Message_Body>(): IPubsub_Client<MessageType, BodyType> => {
  if(!socketClient) throw new Error(`no socket client setup`)
  return socketClient as unknown as IPubsub_Client<MessageType, BodyType>
}

export const getSocketClientFactory = <MessageType = IPubsub_Message_Type, BodyType = IPubsub_Message_Body>(): {
  (): IPubsub_Client<MessageType, BodyType>,
} => {
  return () => {
    return getSocketClient<MessageType, BodyType>()
  }
}
